import { useAgentStore } from '@/stores/agentStore';
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: '',
    redirect: '/en/echo',
  },
  {
    path: '/:lang/echo',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
  },
  {
    path: '/:lang/echo/conversation/:id?',
    name: 'conversation',
    component: () =>
      import(
        /* webpackChunkName: "conversation" */ '../views/ConversationView.vue'
      ),
    props: (route) => ({
      id: route.params.id,
      lang: route.params.lang,
      shouldReset: route.query.shouldReset === 'true',
    }),
    beforeEnter: (_to, _from, next) => {
      const agentStore = useAgentStore();
      if (!_to.params.id && !agentStore.selectedAgent) {
        next({ name: '' });
      } else {
        next();
      }
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
